import React, { FC } from 'react';
import { Section } from '../../layout/Section';
import { Layout } from '../../layout/Layout';
import { Header, Title, Container } from './PageHeader.styles';
import { TagType } from '../../../old/storyblok/tags-context';
import { AuthorType } from '../../../old/storyblok/authors-context';

export type PageHeaderProps = {
  title?: string;
  tags?: TagType[];
  authors?: AuthorType[];
};

const PageSimpleHeaderBlok: FC<PageHeaderProps> = ({ title }) => {
  return (
    <Section>
      <Layout>
        <Container>
          {title && (
            <Header>
              <Title>{title}</Title>
            </Header>
          )}
        </Container>
      </Layout>
    </Section>
  );
};

export default PageSimpleHeaderBlok;
